module.exports = __webpack_public_path__ + "static/media/sotyktu_ios_pass_mobile.c4f3c3c7.png";